import { render } from "./header.vue?vue&type=template&id=f1c0cb20&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=f1c0cb20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f1c0cb20"

export default script